import { compareMeetingSessionRoles, useMeetingSelector } from "@kalyzee/kast-web-sdk";
import { DEFAULT_BOARD_MATCH } from "../helpers/defaultMatchers";
import { matchEngine } from "../helpers/matchEngine";
import { useLocalOrRemoteMedia } from "./ovenmedia";
import { useCallback } from "react";
import { MeetingSession, MeetingSessionMedia } from "@kalyzee/kast-web-sdk/websocket";
import { useMeetingUtilsContext } from "../contexts/meetingUtils/context";
import { useFeatures } from "./features";

const roleComparator = { "session.role": (a: any, b: any) => -compareMeetingSessionRoles(a, b) };

export const useBoardMedia = () => {
  const { containerAPI, populated } = useMeetingUtilsContext();
  const [currentSession] = useMeetingSelector(containerAPI, "session");

  const features = useFeatures();

  const activity = populated.activity;

  return useLocalOrRemoteMedia(
    containerAPI,
    useCallback((s: MeetingSession, media: MeetingSessionMedia) => {
      const highlighted = activity?.mode === "highlight"
        && activity.confirmedSessions.some(cs => cs.session.id === s.id);
      const match = matchEngine(
        {
          session: s,
          media,
          currentSession,
          highlighted: !!highlighted,
        },
        features.boardMatch || DEFAULT_BOARD_MATCH,
        roleComparator,
      );
      return match;
    }, [activity, currentSession, features.boardMatch]),
  );
};